import Component from "../../classes/Component";
import {$events} from "../../helpers/events";
import {$dom} from "../../helpers/dom";
import variables from "../../variables";

const {removeClass, addClass, get, getAll} = $dom

const formGroupSelector = '.js-getting-checkbox-group'
const formWrapperSelector = '.js-getting-checkbox-wrapper'
const gettingCheckboxSelector = '.js-getting-checkbox'
const gettingContentSelector = '.js-getting-wrapper-content'

export default function () {
    const handleChecked = (e) => {
        const type = e.target.closest(formWrapperSelector).dataset['type']

        const content = get(gettingContentSelector + ` > div[data-content=${type === 'post' ? 'pickup' : type}]`)

        switch (type) {
            case 'pickup':
                hiddenAllContent()
                content.classList.remove('hidden')

                break

            case 'post':
                hiddenAllContent()
                content.classList.remove('hidden')

                break

            case 'ozon':
                hiddenAllContent()
                content.classList.remove('hidden')

                break

            case 'courier':
                hiddenAllContent()
                content.classList.remove('hidden')

                break

            case 'courier_ozon':
                hiddenAllContent()
                content.classList.remove('hidden')

                break

            default:
                break
        }
    }

    const hiddenAllContent = () => {
        const contents = getAll(gettingContentSelector + ' > div')

        contents.forEach(item => item.classList.add(variables.classNames.hidden))
    }

    return new Component({
        name: 'gettingWay',
        requiredTargets: [
            gettingCheckboxSelector,
            formGroupSelector,
            gettingContentSelector,
            formWrapperSelector
        ],
        onInit() {
            $events.delegate.on('input', gettingCheckboxSelector, handleChecked)
        },
        onDestroy() {

        },
    })

}